/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NftType } from './NftType';
import {
    NftTypeFromJSON,
    NftTypeFromJSONTyped,
    NftTypeToJSON,
    NftTypeToJSONTyped,
} from './NftType';
import type { EVMChain } from './EVMChain';
import {
    EVMChainFromJSON,
    EVMChainFromJSONTyped,
    EVMChainToJSON,
    EVMChainToJSONTyped,
} from './EVMChain';

/**
 * Used to save a NFT mint transaction.
 * @export
 * @interface NftMintTransaction
 */
export interface NftMintTransaction {
    /**
     * 
     * @type {string}
     * @memberof NftMintTransaction
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof NftMintTransaction
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof NftMintTransaction
     */
    updatedAt: number;
    /**
     * 
     * @type {string}
     * @memberof NftMintTransaction
     */
    user: string;
    /**
     * 
     * @type {string}
     * @memberof NftMintTransaction
     */
    nftTracker?: string;
    /**
     * 
     * @type {boolean}
     * @memberof NftMintTransaction
     */
    isComplete: boolean;
    /**
     * 
     * @type {string}
     * @memberof NftMintTransaction
     */
    contractAddress?: string;
    /**
     * 
     * @type {object}
     * @memberof NftMintTransaction
     */
    error?: object;
    /**
     * 
     * @type {string}
     * @memberof NftMintTransaction
     */
    walletAddress?: string;
    /**
     * 
     * @type {string}
     * @memberof NftMintTransaction
     */
    transactionHash?: string;
    /**
     * 
     * @type {number}
     * @memberof NftMintTransaction
     */
    userLevel?: number;
    /**
     * 
     * @type {number}
     * @memberof NftMintTransaction
     */
    nftId?: number;
    /**
     * 
     * @type {object}
     * @memberof NftMintTransaction
     */
    receipt?: object;
    /**
     * 
     * @type {boolean}
     * @memberof NftMintTransaction
     */
    isVirtual?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof NftMintTransaction
     */
    nftOwnerships?: Array<string>;
    /**
     * 
     * @type {NftType}
     * @memberof NftMintTransaction
     */
    type: NftType;
    /**
     * 
     * @type {EVMChain}
     * @memberof NftMintTransaction
     */
    chain: EVMChain;
}



/**
 * Check if a given object implements the NftMintTransaction interface.
 */
export function instanceOfNftMintTransaction(value: object): value is NftMintTransaction {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('user' in value) || value['user'] === undefined) return false;
    if (!('isComplete' in value) || value['isComplete'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('chain' in value) || value['chain'] === undefined) return false;
    return true;
}

export function NftMintTransactionFromJSON(json: any): NftMintTransaction {
    return NftMintTransactionFromJSONTyped(json, false);
}

export function NftMintTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftMintTransaction {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
        'user': json['user'],
        'nftTracker': json['nftTracker'] == null ? undefined : json['nftTracker'],
        'isComplete': json['isComplete'],
        'contractAddress': json['contractAddress'] == null ? undefined : json['contractAddress'],
        'error': json['error'] == null ? undefined : json['error'],
        'walletAddress': json['walletAddress'] == null ? undefined : json['walletAddress'],
        'transactionHash': json['transactionHash'] == null ? undefined : json['transactionHash'],
        'userLevel': json['userLevel'] == null ? undefined : json['userLevel'],
        'nftId': json['nftId'] == null ? undefined : json['nftId'],
        'receipt': json['receipt'] == null ? undefined : json['receipt'],
        'isVirtual': json['isVirtual'] == null ? undefined : json['isVirtual'],
        'nftOwnerships': json['nftOwnerships'] == null ? undefined : json['nftOwnerships'],
        'type': NftTypeFromJSON(json['type']),
        'chain': EVMChainFromJSON(json['chain']),
    };
}

export function NftMintTransactionToJSON(json: any): NftMintTransaction {
    return NftMintTransactionToJSONTyped(json, false);
}

export function NftMintTransactionToJSONTyped(value?: NftMintTransaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'user': value['user'],
        'nftTracker': value['nftTracker'],
        'isComplete': value['isComplete'],
        'contractAddress': value['contractAddress'],
        'error': value['error'],
        'walletAddress': value['walletAddress'],
        'transactionHash': value['transactionHash'],
        'userLevel': value['userLevel'],
        'nftId': value['nftId'],
        'receipt': value['receipt'],
        'isVirtual': value['isVirtual'],
        'nftOwnerships': value['nftOwnerships'],
        'type': NftTypeToJSON(value['type']),
        'chain': EVMChainToJSON(value['chain']),
    };
}

